import { FC } from 'react';
import { ContentLoader } from '@edikk-edikk/country-common';
import { useBaseContext } from '#base/hooks/use-base-context';
import { LoadMore } from '#advertList/components/catalog-by-date/LoadMore';
import { useAdvertListContext } from '#advertList/hooks';
import { AdvertCardList, CatalogMode } from '#advert/components/card-list';
import catalogLoaderCss from '../../assets/catalog-loader.module.scss';

const CatalogByDate: FC = () => {
  const { catalogMode } = useBaseContext();
  const { advertDataListByDate, isFetching } = useAdvertListContext();

  if (catalogMode !== CatalogMode.default) {
    return null;
  }

  if (isFetching) {
    return <ContentLoader additionalClassName={catalogLoaderCss.catalogLoader} />;
  }

  const adverts = advertDataListByDate.chunkDataList.flatMap((chunk) => chunk.adverts);

  return (
    <>
      <AdvertCardList
        adverts={adverts}
        total={advertDataListByDate.pagination.totalCount}
      />
      <LoadMore />
    </>
  );
};

export { CatalogByDate };
